// 监听容器高度变化
import throttle from 'lodash/throttle';

export const heightListen = (el: any, callback: any) => {
    const MutationObserver = window.MutationObserver || window.webkitMutationObserver || window.MozMutationObserver;
    let recordHeight = 0;
    const onHeightChange = throttle(() => {
        const height = window.getComputedStyle(el).getPropertyValue('height');
        if (height === recordHeight) {
            return;
        }
        recordHeight = height;
        // console.log('高度变化了')
        callback && callback();
    }, 500);

    el.__onHeightChange__ = onHeightChange;

    el.addEventListener('animationend', onHeightChange);

    el.addEventListener('transitionend', onHeightChange);

    el.__observer__ = new MutationObserver(() => {
        onHeightChange();
    });

    el.__observer__.observe(el, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
    });

    el.clear = () => {
        if (el.__observer__) {
            el.__observer__.disconnect();
            el.__observer__ = null;
        }
        el.removeEventListener('animationend', el.__onHeightChange__);
        el.removeEventListener('transitionend', el.__onHeightChange__);
        el.__onHeightChange__ = null;
    };

    return el;
};

export const onEleVisible = (ele: Element, callback: () => void, offset = 0) => {
    if (!ele) throw new Error('video dom can not null');
    const isNotCompatibleBrowser = getIsNotCompatibleBrowser();
    const onScroll = () => {
        const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const svgVideoRect = ele?.getBoundingClientRect();
        const { bottom, y } = svgVideoRect;
        if (bottom < viewPortHeight + offset && bottom > 0 && !isNotCompatibleBrowser) {
            callback();
            // 播放一次后，解除监听事件
            window.removeEventListener('scroll', onScroll);
        } else if (Math.abs(viewPortHeight - bottom) < 100 && bottom > 0 && isNotCompatibleBrowser) {
            callback();
            // 播放一次后，解除监听事件
            window.removeEventListener('scroll', onScroll);
        }
    };
    window.addEventListener('scroll', onScroll);

    // 存储解除监听函数
    onEleVisible.listenerList = onEleVisible.listenerList || [];
    onEleVisible.listenerList.push(() => window.removeEventListener('scroll', onScroll));
};
// 暴露调用解除监听函数
onEleVisible.clear = () => {
    onEleVisible.listenerList?.forEach((item) => item());
    onEleVisible.listenerList = [];
};

// 判断是否是Safari浏览器
export const getIsNotCompatibleBrowser = () => {
    if (typeof window !== 'undefined') {
        return (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) || /QQBrowser/.test(navigator.userAgent);
    }
    return false;
};

type config = {
    loop?: boolean;
    lazyPlay?: boolean;
    fps?: number;
    offset?: number;
};
export class SvgFrameAnimation {
    private readonly count: number;
    private readonly ele: Element;
    private readonly images: string[];
    private i: number;
    private stop: boolean;
    private config: config;
    private timer: any;

    constructor(ele: Element, images: string[], config: config) {
        if (!ele || !images) throw new Error('ele和images是必填参数');

        if (!Array.isArray(images)) throw new Error('images为数组类型');

        this.i = 0;
        this.count = images.length - 1;
        this.stop = false;

        this.ele = ele;
        this.images = images;
        this.config = config;

        if (this.config.lazyPlay) {
            onEleVisible(this.ele, this.play.bind(this), this.config.offset);
        } else {
            this.play();
        }
    }

    private play() {
        this.ele.setAttribute('href', this.images[this.i]);

        if (this.i < this.count) {
            this.i++;
        } else {
            if (!this.config.loop) this.stop = true;
            this.i = 0;
        }

        if (!this.stop) {
            this.timer = setTimeout(() => this.play(), 1000 / (this.config.fps || 24));
        }
    }

    public rePlay() {
        if (!this.config.loop && this.stop) {
            this.stop = false;
            this.play();
        }
    }

    public clear() {
        clearTimeout(this.timer);
        onEleVisible.clear();
    }
}
